module.exports = __webpack_public_path__ + "static/media/sliderItem5.ffdfae5a.JPG";